module.exports = __webpack_public_path__ + "img/user_img.8822d737.png";